// The portal isn't a daily punch-clock — it's a tool to fill in the monthly
// payroll spreadsheet. We restrict editable months to the current month and
// the previous month, so people can finalise the past month right after
// month-break and prepare the current month if they want.

export interface MonthRef {
  year: number;
  month: number;
}

export function defaultReportingMonth(today = new Date()): MonthRef {
  // If we're in the first 10 days of a month, default to the *previous* month
  // (the most likely thing the user wants to finalise). Otherwise the current.
  if (today.getDate() <= 10) {
    const prev = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    return { year: prev.getFullYear(), month: prev.getMonth() + 1 };
  }
  return { year: today.getFullYear(), month: today.getMonth() + 1 };
}

export function editableRange(today = new Date()): { from: MonthRef; to: MonthRef } {
  const prev = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  return {
    from: { year: prev.getFullYear(), month: prev.getMonth() + 1 },
    to: { year: today.getFullYear(), month: today.getMonth() + 1 },
  };
}

export function isEditableMonth(year: number, month: number, today = new Date()): boolean {
  const range = editableRange(today);
  const cur = year * 12 + month;
  const from = range.from.year * 12 + range.from.month;
  const to = range.to.year * 12 + range.to.month;
  return cur >= from && cur <= to;
}
